import { useCallback, useEffect } from "react";
import { useDispatch } from "react-redux";

import { useDialogsProvider } from "2g-dialogs-provider";
import ZpracDialog from "2g-zprac-dialog";
import { actions as formActions } from "2g-form";
import { dispatchModuleAction } from "2g-utils-redux";

import { ADMIN } from "b2b/api/paths";
import { PATHS } from "b2b/constants";
import { useRedirect } from "b2b/hooks";
import useMessages from "./i18n/useMessages";

export const FORM_MODULE_KEY = "produktEditaceForm";

export default function useProduktEditaceWidget({ produkt }) {
  const { saveDialogTitle, deleteDialogTitle } = useMessages();
  const { showDialog, hideDialog } = useDialogsProvider();
  const dispatch = useDispatch();
  const redirect = useRedirect();

  useEffect(() => {
    produkt &&
      dispatchModuleAction(
        dispatch,
        FORM_MODULE_KEY,
        formActions.setValues(produkt)
      );
  }, [produkt]);

  const redirectToZdroje = useCallback(() => {
    redirect(PATHS.ADMINISTRACE.ZDROJE);
  }, [redirect]);

  const handleSuccess = useCallback(() => {
    hideDialog();
    redirectToZdroje();
  }, [hideDialog, redirectToZdroje]);

  const handleSubmit = useCallback(
    ({ values, submitter }) => {
      showDialog(ZpracDialog, {
        url: ADMIN.produkt(values.id),
        method: values.id ? "put" : "post",
        payload: values,
        title: saveDialogTitle(),
        onClose: hideDialog,
        onSuccess: handleSuccess
      });
    },
    [showDialog, handleSuccess]
  );

  const handleDelete = useCallback(() => {
    showDialog(ZpracDialog, {
      url: ADMIN.produkt(produkt.id),
      method: "delete",
      title: deleteDialogTitle(),
      onClose: hideDialog,
      onSuccess: handleSuccess
    });
  }, [produkt?.id, handleSuccess]);

  return {
    formModuleKey: FORM_MODULE_KEY,
    onSubmit: handleSubmit,
    onCancel: redirectToZdroje,
    onDelete: handleDelete
  };
}
